const FILTER_KEYS = ["from", "to", "municipality", "bairro", "dateField", "groupBy", "zone", "localityType", "localityId"];

function readNatureIds(params, saved) {
  if (params.has("natureIds")) {
    return [...new Set(params.getAll("natureIds")
      .flatMap((value) => value.split(","))
      .map((value) => value.trim())
      .filter(Boolean))];
  }
  if (params.has("natureId")) return params.get("natureId") ? [params.get("natureId")] : [];
  if (Array.isArray(saved.natureIds)) return [...new Set(saved.natureIds.map(String))];
  return saved.natureId ? [String(saved.natureId)] : [];
}

export function readFiltersFromLocation(location, defaults = {}) {
  const params = new URLSearchParams(location.search || "");
  const saved = location.state?.filters || {};
  const queryFilters = Object.fromEntries(FILTER_KEYS
    .filter((key) => params.has(key))
    .map((key) => [key, params.get(key)]));
  const natureIds = readNatureIds(params, saved);
  return {
    ...defaults,
    ...saved,
    ...queryFilters,
    natureIds,
    natureId: natureIds.length === 1 ? natureIds[0] : "",
    compareWithPrevious: params.has("compare")
      ? params.get("compare") === "1"
      : Boolean(saved.compareWithPrevious),
  };
}

export function buildFilterSearch(filters) {
  const params = new URLSearchParams();
  FILTER_KEYS.forEach((key) => {
    if (filters[key] !== undefined && filters[key] !== null && filters[key] !== "") {
      params.set(key, String(filters[key]));
    }
  });
  const natureIds = [...new Set((filters.natureIds || [])
    .map(String)
    .filter(Boolean))];
  if (natureIds.length) params.set("natureIds", natureIds.join(","));
  if (filters.compareWithPrevious) params.set("compare", "1");
  return params.toString();
}
